import { useQuery } from "@tanstack/react-query";

import { api } from "../../api/client";
import type { App6Palette } from "../../api/types";
import { paletteOf } from "./app6";

/** Palette APP-6 pour les fiches et listes hors de l'éditeur (fiche d'unité, sélecteur de force) : celle du
 *  vocabulaire ami, chargée une fois et seulement quand une unité construite est montrée. */
export function useApp6Palette(enabled = true): App6Palette {
  const { data } = useQuery({
    queryKey: ["odb-vocabulary", "AMI"],
    queryFn: () => api.odbVocabulary("AMI"),
    staleTime: Infinity,
    enabled,
  });
  return paletteOf(data);
}
